var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn customize-layout",class:_vm.buttonTypeClass,attrs:{"type":"button","id":_vm.id,"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }